import { Component, OnInit, Input, ViewChild, ElementRef, Output, EventEmitter } from '@angular/core';
import { toNumber } from 'lodash';
// Services
import { ViewsService } from '../../../../../../services/views.service';
import { SchemasService } from '../../../../../../services/schemas.service';
// Components

@Component({
	selector: 'cv-schema-render-form-display',
	templateUrl: './display-fields.component.html'
})
export class FormDisplayFieldComponent implements OnInit {
	@Input() fieldOptions: any;
	@Input() field: any;
	@Input() value: any = null;
	@Input() historical: Array<any>;
	@Input() show: any;
	@Input() active = false;
	@Output() openHistorical: EventEmitter<any> = new EventEmitter<any>();

	@ViewChild('changesEl', { read: ElementRef, static: false }) changesEl: ElementRef;

	targets = [];
	highlight = '';

	iconExist = false;
	icon = '';
	icons = {
		'stable': 'fa fa-arrows-alt-h',
		'decreasing': 'fa fa-arrow-circle-down',
		'declining': 'fa fa-arrow-circle-down',
		'slow': 'fa fa-arrow-circle-down',
		'increasing': 'fa fa-arrow-circle-up',
		'rapid': 'fa fa-arrow-circle-up',
		'yes': 'fa fa-check',
		'no': 'fa fa-times',
		'avg': 'fa fa-star-half-alt',
		'gd': 'fa fa-star',
		'good': 'fa fa-star',
		'average': 'fa fa-star-half-alt',
		'poor': 'far fa-star'
	};

	async ngOnInit(): Promise<void> {
		if (typeof this.value === 'string' && this.value.toLocaleLowerCase() in this.icons) {
			this.icon = this.value.toLocaleLowerCase();
			this.iconExist = true;
		}

		if (typeof this.value === 'string' && this.value !== '') {
			this.value = this.value.replace(/([a-z])([A-Z])/g, '$1 $2');
			this.value = this.value.replace(/([a-z])([1-9])/g, '$1 $2');
			this.value = this.value.replace(/([1-9])([A-Z])/g, '$1 $2');
		}
	}

	/**
	 * open historical component
	 * @param item
	 * @param historical
	 */
	showHistorical(): void {
		this.openHistorical.emit(this.changesEl);
	}

	/**
	 * parseNumeric
	 * 
	 * @param value 
	 */
	parseNumeric(value: any): any {
		const newVal = toNumber(value.replace(/,/g, ''));
		return newVal;
	}

	/**
	 * isNumber 
	 * 
	 * @param val 
	 */
	isNumber(value: any): boolean {
		const test = parseFloat(value);
		return typeof test === 'number' && !isNaN(test);
	}
}
